export default {
  setPrograms(state, programs) {
    state.programs = programs
  },
  setProgram(state, program) {
    state.program = program
  },
  setLoading(state, loading) {
    state.loading = loading
  },
}
